'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _INT_ONE = require('permanent/es/INT_ONE');

var _INT_ONE2 = _interopRequireDefault(_INT_ONE);

var _INT_ZERO = require('permanent/es/INT_ZERO');

var _INT_ZERO2 = _interopRequireDefault(_INT_ZERO);

var _NULL = require('permanent/es/NULL');

var _NULL2 = _interopRequireDefault(_NULL);

var _len2 = require('./_internal/_len');

var _len3 = _interopRequireDefault(_len2);

var _args = require('./args');

var _args2 = _interopRequireDefault(_args);

var _at = require('./at');

var _at2 = _interopRequireDefault(_at);

var _call = require('./call');

var _call2 = _interopRequireDefault(_call);

var _compose = require('./compose');

var _compose2 = _interopRequireDefault(_compose);

var _equals = require('./equals');

var _equals2 = _interopRequireDefault(_equals);

var _getEmptyObj = require('./getEmptyObj');

var _getEmptyObj2 = _interopRequireDefault(_getEmptyObj);

var _isNull = require('./isNull');

var _isNull2 = _interopRequireDefault(_isNull);

var _isString = require('./isString');

var _isString2 = _interopRequireDefault(_isString);

var _merge = require('./merge');

var _merge2 = _interopRequireDefault(_merge);

var _ternaryWith = require('./ternaryWith');

var _ternaryWith2 = _interopRequireDefault(_ternaryWith);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Forces value into object. If not object, returns {}
 *
 * @module toObject
 * @func
 * @since 1.0.0
 * @param {*} value
 * @return {Object}
 * @example
 *
 *     toObject({ a: 1 }); //=> { a: 1 }
 *     toObject(null); //=> null
 *     toObject('foo'); //=> {}
 */

var atZero = (0, _at2.default)(_INT_ZERO2.default);
var equalsOne = (0, _equals2.default)(_INT_ONE2.default);
var equalsZero = (0, _equals2.default)(_INT_ZERO2.default);
var assignMultiple = (0, _call2.default)(_merge2.default);
var assignOne = (0, _compose2.default)(_merge2.default, atZero);
var isStringAtZero = (0, _compose2.default)(_isString2.default, atZero);
var isNullAtZero = (0, _compose2.default)(_isNull2.default, atZero);
var lenEqualsOne = (0, _compose2.default)(equalsOne, _len3.default);
var lenEqualsZero = (0, _compose2.default)(equalsZero, _len3.default);
var ifString = (0, _ternaryWith2.default)(assignOne, _getEmptyObj2.default, isStringAtZero);
var ifNull = (0, _ternaryWith2.default)(ifString, _NULL2.default, isNullAtZero);
var ifLengthOne = (0, _ternaryWith2.default)(assignMultiple, ifNull, lenEqualsOne);
var ifLengthZero = (0, _ternaryWith2.default)(ifLengthOne, _getEmptyObj2.default, lenEqualsZero);

var toObject = (0, _compose2.default)(ifLengthZero, _args2.default);

exports.default = toObject;